export function getScanChapters(activityModel) {
    const chapterIds = Object.keys(activityModel.get('scan').task_groups_per_chapter)
    return chapterIds.map((chapterId) => {
        return Backbone.Collection.chapters.get(chapterId)
    })
}

export function getAttainableTestScoreForChapter(activityModel, chapterId) {
    const taskGroupIds = activityModel.get('scan').task_groups_per_chapter[chapterId]
    return taskGroupIds.reduce((total, taskGroupId) => {
        const taskGroup = activityModel.task_groups.get(taskGroupId)
        if (taskGroup) {
            total += taskGroup.tasks.length
        }
        return total
    }, 0)
}

export function getScoreForChapter(activityModel, chapterId, userId) {
    // Backend calculates score for when the user is a student.
    if (userId === undefined) {
        return activityModel.get('scan').score_per_chapter[chapterId]?.scored ?? 0
    }
    // Otherwise, calculate score based on responses.
    const taskGroupIds = activityModel.get('scan').task_groups_per_chapter[chapterId]
    return activityModel.responses.reduce((total, response) => {
        if (
            response.get('user_id') === userId &&
            response.has('json_answer') &&
            response.get('score') > -1 &&
            taskGroupIds.includes(activityModel.tasks.get(response.get('task_id'))?.get('task_group_id'))
        ) {
            total += response.get('score')
        }
        return total
    }, 0)
}

export function getScanAdvice(activityModel) {
    const advice = getScanChapters(activityModel).reduce((m, chapter) => {
        m.score += getScoreForChapter(activityModel, chapter.id)
        m.attainableScore += getAttainableTestScoreForChapter(activityModel, chapter.id)
        return m
    }, {score: 0, attainableScore: 0})

    const normalizedScore = (advice.score / advice.attainableScore) || 0
    if (normalizedScore < 0.4) {
        advice.label = activityModel.get('scan').metadata.below_level
        advice.color = 'red'
    } else if (normalizedScore < 0.9) {
        advice.label = activityModel.get('scan').metadata.on_level
        advice.color = 'orange'
    } else {
        advice.label = activityModel.get('scan').metadata.above_level
        advice.color = 'green'
    }

    return advice
}
